import { Product } from '@diamond/shared/types';

type IncomingProduct = Partial<Product> & {
  name?: string;
  product_images?: string[];
};

// Map a list of API products into UI Product[]
export function mapApiProductsToUI(
  products: IncomingProduct[] = []
): Product[] {
  const toProduct = (p: IncomingProduct): Product => {
    const prices = p.prices ?? [{ price: 0, min_order_quantity: 1 }];
    const product_images_medium =
      p.product_images_medium ?? p.product_images ?? [];
    const stock = p.stock ?? 0;
    const stock_status =
      p.stock_status ?? (stock > 0 ? 'AVAILABLE' : 'OUT_OF_STOCK');

    return {
      ...p,
      id: p.id ?? '',
      brand_desc: p.brand_desc ?? p.name ?? '',
      item_code: p.item_code ?? '',
      prices,
      product_images_medium,
      sales_unit: p.sales_unit ?? '',
      pack_unit: p.pack_unit ?? '',
      title: p.title ?? p.name ?? '',
      stock,
      stock_status,
    } as Product;
  };

  return (products ?? []).map(toProduct);
}
